import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(180);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const isUrgent = timeLeft <= 60;
  return <motion.div className={`fixed top-0 left-0 right-0 z-50 py-2.5 px-4 flex items-center justify-center gap-3 shadow-sm transition-colors ${isUrgent ? 'bg-terracotta text-white' : 'bg-olive text-white'}`} initial={{
    opacity: 0,
    y: -40
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5
  }} data-id="element-87">
      <Clock className="w-4 h-4 shrink-0" data-id="element-88" />
      {timeLeft > 0 ? <div className="flex items-center gap-2 flex-wrap justify-center" data-id="element-89">
          <span className="text-sm font-medium" data-id="element-90">
            Oferta especial termina en:
          </span>
          <div className="flex items-center gap-1" data-id="element-91">
            <span className="font-mono text-lg font-bold tabular-nums" data-id="element-92">
              {String(minutes).padStart(2, '0')}
            </span>
            <span className={`text-lg font-bold ${isUrgent ? 'animate-pulse' : ''}`} data-id="element-93">
              :
            </span>
            <span className="font-mono text-lg font-bold tabular-nums" data-id="element-94">
              {String(seconds).padStart(2, '0')}
            </span>
          </div>
          <a href="https://epikkastore.com/cart/45054208213015:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className={`text-xs font-bold px-4 py-1.5 rounded-full transition-colors ml-2 ${isUrgent ? 'bg-white text-terracotta hover:bg-white/90' : 'bg-white text-olive hover:bg-white/90'}`} data-id="element-95">
            Comprar ahora
          </a>
        </div> : <span className="text-sm font-medium" data-id="element-96">¡La oferta ha expirado!</span>}
    </motion.div>;
}